import { useRef, useEffect } from 'react'

const useNonInitialEffect = (effect, deps) => {
  const initialRender = useRef(true)

  useEffect(() => {
    let effectReturns = () => {}

    if (initialRender.current) {
      initialRender.current = false
    } else {
      effectReturns = effect()
    }

    if (effectReturns && 'function' == typeof effectReturns) {
      return effectReturns
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}

export default useNonInitialEffect
